<template>
  <section
    class="section7-container"
    data-aos="fade-in"
  >
    <part4 />
    <!-- <part5 /> -->
    <part6 class="section7-container-part6" />
  </section>
</template>

<script>
export default {
  components: {
    part4: () => import("./PlanTitle.vue"),
    part5: () => import("./Bulletinboard.vue"),
    part6: () => import("@/components/Mediacoverage.vue"),
    myButton: () => import("@/components/MyButton.vue")
  }
};
</script>

<style lang="less" scoped>
@media (min-width: 501px) {
  .section7-container {
    .section7-part1 {
      background: #3f4ae1;
      .section7-part1-wrapper-content {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        .section7-content {
          .symbol {
            margin-top: 30px;
            width: 91px;
          }
          .intro-content {
            margin-left: 42px;
            // margin: 0 auto;
            .title1 {
              width: 410px;
              font-size: 28px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: rgba(255, 255, 255, 1);
              line-height: 50px;
            }
            .title2 {
              font-size: 24px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
              line-height: 33px;
            }

            .knowMore {
              margin-top: 45px;
            }
          }
          .mobileImg {
            display: none;
          }
        }
        .pcimg {
          display: block;
          margin-left: 20%;
        }
      }
    }
    .section7-part2 {
      height: 111px;
      margin-top: -50px;
      position: relative;
      .section7-part2-wrapper {
        .circle1 {
          position: absolute;
          left: 6%;
          top: 0;
          width: 110px;
          height: 110px;
          border-radius: 50%;
          background-color: #4b8bf6;
        }
        .tangle {
          position: absolute;
          top: 44px;
          left: 50%;
          transform: translateX(-50%);
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 20px 20px 0 20px;
          border-color: #3f49e1 transparent transparent transparent;
        }
        .circle2 {
          position: absolute;
          right: 43px;
          top: 0;
          width: 110px;
          height: 110px;
          border-radius: 50%;
          background-color: #f6b334;
        }
      }
    }

    .section7-part3 {
      // padding-bottom: 120px;
      position: relative;
      overflow: hidden;

      .title1 {
        text-align: center;
        font-size: 28px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(38, 38, 38, 1);
        line-height: 40px;
      }
      .title2 {
        text-align: center;
        margin-bottom: 52px;
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(38, 38, 38, 1);
        line-height: 28px;
      }
      .item-wrapper {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-bottom: 70px;
        .item {
          // padding: 0px 80px;
          width: 25%;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: center;
          .imghoder {
            height: 60px;
            margin-bottom: 10px;
          }
          img {
            display: inline-block;
          }
          p {
            white-space: nowrap;
            font-size: 22px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(38, 38, 38, 1);
            line-height: 30px;
          }
        }
      }
      .red-circle {
        position: absolute;
        top: 30%;
        left: 14%;
        width: 62px;
        height: 62px;
        border-radius: 50%;
        background-color: #e02053;
      }
      .green-circle {
        position: absolute;
        right: -68px;
        bottom: -34px;
        width: 200px;
        height: 200px;
        border-radius: 50%;
        background-color: #42c6ac;
      }
    }

    // .section7-part4 {
    //   height: 372px;
    //   background-color: #ebecfc;
    //   margin-bottom: 50px;
    //   .section7-part4-wrapper {
    //     text-align: right;
    //     h1 {
    //       margin-top: 120px;
    //       margin-right: 450px;
    //       font-size: 28px;
    //       font-family: PingFangSC-Semibold, PingFang SC;
    //       font-weight: 600;
    //       color: rgba(38, 38, 38, 1);
    //       line-height: 40px;
    //     }
    //     h2 {
    //       font-size: 22px;
    //       font-family: PingFangSC-Regular, PingFang SC;
    //       font-weight: 400;
    //       color: rgba(38, 38, 38, 1);
    //       line-height: 30px;
    //     }
    //   }
    // }
    .section7-container-part6 {
      margin-bottom: 80px;
    }
  }
}

@media (max-width: 500px) {
  .section7-container {
    .section7-part1 {
      background: #3f4ae1;
      padding: 50px 0px;
      .section7-part1-wrapper-content {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        .section7-content {
          width: 100vw;
          .symbol {
            width: 91px;
          }
          .intro-content {
            margin: 0 auto;
            .mobileImg {
              max-width: 100%;
              display: block;
            }
            .title1 {
              font-size: 26px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: rgba(255, 255, 255, 1);
              line-height: 37px;
            }
            .title2 {
              font-size: 18px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
              line-height: 28px;
            }

            .knowMore {
              margin-top: 45px;
            }
          }
        }
        .pcimg {
          display: none;
        }
      }
    }
    .section7-part2 {
      position: relative;
      .section7-part2-wrapper {
        .circle1 {
          position: absolute;
          left: -50px;
          top: -22px;
          width: 110px;
          height: 110px;
          border-radius: 50%;
          background-color: #4b8bf6;
        }
        .tangle {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 20px 20px 0 20px;
          border-color: #3f49e1 transparent transparent transparent;
        }
        .circle2 {
          position: absolute;
          right: -60px;
          top: -72px;
          width: 110px;
          height: 110px;
          border-radius: 50%;
          background-color: #f6b334;
        }
      }
    }

    .section7-part3 {
      position: relative;
      overflow: hidden;
      margin-top: 70px;
      .title1 {
        text-align: center;
        font-size: 28px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(38, 38, 38, 1);
        line-height: 40px;
      }
      .title2 {
        text-align: center;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(38, 38, 38, 1);
        line-height: 22px;
      }
      .item-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        flex-wrap: wrap;
        padding-top: 40px;
        padding-bottom: 110px;
        .item {
          width: 50%;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: center;
          .imghoder {
            height: 60px;
            margin-bottom: 10px;
          }
          img {
            display: inline-block;
          }
          p {
            white-space: nowrap;
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(38, 38, 38, 1);
            line-height: 30px;
          }
        }
      }
      .red-circle {
        position: absolute;
        bottom: 84px;
        left: 1%;
        width: 62px;
        height: 62px;
        border-radius: 50%;
        background-color: #e02053;
      }
      .green-circle {
        position: absolute;
        right: -108px;
        bottom: -85px;
        width: 200px;
        height: 200px;
        border-radius: 50%;
        background-color: #42c6ac;
      }
    }

    // .section7-part4 {
    //   height: 372px;
    //   background-color: #ebecfc;
    //   margin-bottom: 50px;
    //   .section7-part4-wrapper {
    //     text-align: right;
    //     h1 {
    //       margin-top: 120px;
    //       margin-right: 450px;
    //       font-size: 28px;
    //       font-family: PingFangSC-Semibold, PingFang SC;
    //       font-weight: 600;
    //       color: rgba(38, 38, 38, 1);
    //       line-height: 40px;
    //     }
    //     h2 {
    //       font-size: 22px;
    //       font-family: PingFangSC-Regular, PingFang SC;
    //       font-weight: 400;
    //       color: rgba(38, 38, 38, 1);
    //       line-height: 30px;
    //     }
    //   }
    // }
    .section7-container-part6 {
      margin-bottom: 80px;
    }
  }
}

@media (min-width: 700px) and (max-width: 1100px) {
  .item-wrapper {
    .item {
      width: 50% !important;
    }
  }
}
</style>
